import React, { Component } from 'react';
import ActionEditorContainer from '../ActionEditorContainer';
import ActionJiraEditorComponent from './ActionJiraEditorComponent';

class ActionJiraEditorContainer extends Component {
  public render() {
    return <ActionEditorContainer editor={<ActionJiraEditorComponent />} type='jira' icon='jira' />;
  }
}

export default ActionJiraEditorContainer;
